import React,{Component}from'react';
import db from '../FirestoreConfig';
import '../App.css';
import '../Background.css';
import utils from '../utils.js';
import _ from 'underscore'
import DiscretizedSlider from '../Components/discretizedSlider'
import MapContainer from './mapSelectLocation'
import LocationSearchInput from './mapSearch'
//TIME PICKER
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import firebase from 'firebase/app';
require('firebase/storage')

export default class Survey extends Component{
    constructor(props)
    {
        super(props)
        this.answerDiscretizedSlider.bind(this)
    }
    state = {
        answers: {},
        mapSearch: {},
        currentScreen: 0,
        totalScreens:0,
        finalScreen:false,
        language: utils.languagePreference,
        lastClickTime:0
    }

    componentDidMount(){
        this.countRead()
        db.collection('surveys').get().then((snapShots) => {
            const surveys = []
            for (let survey of snapShots.docs) {
                surveys.push({
                    id: survey.id,
                    data: survey.data()
                })
            }
            this.setState({
                surveys
            })
        })
        //this.interval = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
    //clearInterval(this.interval);
    }

    countRead(){
        var docName = "reads"
        var docRef = db.collection("reads").doc(docName);
        
        docRef.update({
            reads: firebase.firestore.FieldValue.arrayUnion({seconds: parseInt(Date.now()/1000)})
        }).then(function(){
            console.log('Read counted')
          })
    }

    isAllAnswered = (questions, screenNo) =>
    {
 
        var toReturn = true;
        if(this.state.answers === undefined){
            //console.log("no answers yet");
            toReturn = false;
            return toReturn;
        }

        /*const surveyId = utils.surveyToView

        const {surveys} = this.state
        const surveyData = surveys && surveys.find(function(survey) {return survey.id === surveyId;});*/
        //console.log(screenNo + " -> ");
        //console.log(surveyData && surveyData.data['questions'].length);

        /*surveyData && surveyData.data['questions']*/questions.forEach((question) =>{
            
            if(this.filterConditionedQuestions(question, /*surveyData.data['questions']*/questions) && screenNo === question['screenNumber'] - 1){
                var field = "answer" + question['questionId']
                if(this.state.answers[field] === undefined || (Array.isArray(this.state.answers[field]) && !this.state.answers[field].includes("1"))){
                    console.log("Question " + question['questionId'] + " not answered");
                    toReturn = false;
                    return;
                }
            }            
        })

        //if()
        //console.log("All questions on screen " + screenNo + " answered? " + toReturn);
        return toReturn;

        
    }

    tryGetAnswer = (otherMapID) =>
    {
        var field = "answer" + otherMapID
        
        return this.state.answers[field];
    }

    answer = (question, answerValue) =>
    {
        var field = "answer" + question['questionId']
        var ans = this.state.answers
        //console.log(answerValue); console.log(" vs "); console.log(ans[field]);
        if(ans[field] !== answerValue){
            ans[field] = answerValue
            this.setState({
                answer: ans,
            })
            console.log(this.state.answer);
        }else{
            //console.log(question['questionId'] + " same answer: " + ans[field] + " vs " + answerValue);
        }
    }

    numberChanged = (question, val, minVal, maxVal) =>
    {        
        var answ = val;

        if(Number.isNaN(answ))
            answ = 0;

        if(answ < minVal)
        answ = minVal;
        if(answ > maxVal)
        answ = maxVal;

        this.answer(question, answ);

        console.log(this.state.answer)
    }

    numberChange = (question, val, defaultValue, minVal, maxVal) =>
    {
        var field = "answer" + question['questionId']
        var answ = 0;
        if(this.state.answers[field] === undefined){
            answ =Number.parseInt(defaultValue) + Number.parseInt(val);
        }else{
            answ= Number.parseInt(this.state.answers[field]) + Number.parseInt(val);
        }

        if(answ < minVal)
        answ = minVal;
        if(answ > maxVal)
        answ = maxVal;

        this.answer(question, answ);

    }

    rangeNumberChange = (key, question, val, defaultValue, minVal, maxVal) =>
    {
        var field = "answer" + question['questionId']
        var answ = defaultValue;
        var answers = this.state.answers;
        if(answers[field] !== undefined){
            answ['min'] = Number.parseInt(answers[field]['min'] + "");
            answ['max'] = Number.parseInt(answers[field]['max'] + "");
        }else{
            console.log("here!");
        }

        answ[key]= Number.parseInt(val);
        
        if(answ[key] < minVal)
        answ[key] = minVal;
        if(answ[key] > maxVal)
        answ[key] = maxVal;


            answers[field] = answ;
            this.setState({
                answer: answers,
            })
            console.log(this.state.answer);

        //this.answer(question, answ);

    }

    


    answerTimePicker = (question) =>
    {
        var field1 = "timePicker"+question['questionId']+"1"
        var field2 = "timePicker"+question['questionId']+"2"
        if(this.refs[field1].state.value)
            var answerHour1 = this.refs[field1].state.value['_d'].getHours()+":"+this.refs[field1].state.value['_d'].getMinutes()
        if(this.refs[field2].state.value)
            var answerHour2 = this.refs[field2].state.value['_d'].getHours()+":"+this.refs[field2].state.value['_d'].getMinutes()
        this.answer(question, answerHour1+"/"+answerHour2)
    }
    answerTextIntroduction = (question) =>
    {
        var field = "textIntroduction"+question['questionId']
        var answerText = this.refs[field].value
        this.answer(question, answerText)
    }

    answerMultipleSelection = (question, answerValue, answerIdentifier, answerTypeRef) =>{
        var field = answerTypeRef+question['questionId']+answerValue
        const checked = []
        this.refs[field].value = 1 - this.refs[field].value

        var checkCount = question['posibleAnswers']
        .filter(ans => this.refs[answerTypeRef+question['questionId']+ans[answerIdentifier]].value === '1').length
        
        //console.log(checkCount);

        if(this.refs[field].value === '1' && checkCount <= question['answersLimit'])
            this.refs[field].className = 'buttonSel selected'//question['selectedStyle']
        else
        {
            this.refs[field].className = 'buttonSel unselected'
            this.refs[field].value = 0
        }

        question['posibleAnswers'].map((ans,i) =>
                checked.push(this.refs[answerTypeRef+question['questionId']+ans[answerIdentifier]].value)
        )

        this.answer(question, checked)
    }
    answerDiscretizedSlider = (question) =>
    {
        var field = "discretizedSlider"+question['questionId']
        var answerText = this.refs[field].state['answer']
        this.answer(question, answerText)
    }

    getValue = (question, defaultValue) =>
    {
        
        var field = "answer" + question['questionId']
        if(this.state.answers[field] == null)
            this.answer(question, defaultValue)
        return this.state.answers[field]
        
        
    }

    onChangeRangeSlider = (question) =>
    {
        var field = "slider" + question['questionId']
        var fieldValue = "sliderValue"+question['questionId']
        this.refs[fieldValue].innerHTML = this.refs[field].value
        this.answer(question, this.refs[field].value)
    }
    
     onNext = (screen, questions) =>
    {
        var currentTime = new Date();
        if(currentTime - this.state.lastClickTime < 2000)
            return

        var augment = screen > this.state.currentScreen ? 1 : -1;
        
        //var screen = this.state.currentScreen + 1
        this.setState({
            currentScreen: screen,
        })

        if(augment > 0){
            if(questions.filter(question => question['screenNumber']-1 === screen).length === 0)
            {
                this.setState({
                    finalScreen: true,
                })
                return;
            }
        }else{
            this.setState({
                finalScreen: false
            })
        }

        //
        var areQuestions = false;
        questions.forEach((question) =>{
            if(this.filterConditionedQuestions(question, questions) && screen === question['screenNumber'] - 1){
                areQuestions = true;
                console.log("there is a question: " + question + " on screen " + screen);
                return;
            } 
        })

        console.log("Are questions on screen " + screen + "? " + areQuestions);
        if(augment > 0 || (augment < 0 && screen > 0))
            if(!areQuestions)
                this.onNext(screen + augment, questions);
        
        this.setState({
            lastClickTime: currentTime
        })
        //RELLENAR RESPUESTAS YA CONTESTADAS POR SI VUELVE A LA ANTERIOR/SIGUIENTE!!!
    }

    /*onPrevious = (screen, questions) =>
    {
        var screen = this.state.currentScreen - 1
        this.setState({
            currentScreen: screen,
            finalScreen: false
        })
        //RELLENAR RESPUESTAS YA CONTESTADAS POR SI VUELVE A LA ANTERIOR/SIGUIENTE!!!
    }*/

    onSubmit = () =>
    {

        var ans = this.state.answers
        var date = Date.now()
        ans['date'] = new Intl.DateTimeFormat('es-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', millisecond: '10-digit'}).format(date)
        ans['milliseconds'] = date
        var field = this.refs['email'];
        if(field !== undefined){
            ans['email'] =  field.value;
        }
        
        this.setState({
            answers: ans
        })

        this.countRead()

        db.collection('answers').get().then((snapShots) => {
            const docs = snapShots.docs.filter((doc)=>doc.id.includes(utils.surveyToView))
            
            const actualDocN = Math.max(...docs.map((doc) => {
                var number = doc.id.substring(doc.id.length - 1)
                if(isNaN(number))
                    return 0
                else
                    return(parseInt(number))
            }))
            var nextDocN = actualDocN + 1
            var actualDocNString = actualDocN === 0? "": (""+actualDocN)
            var actualDocName = "answers"+ utils.surveyToView + actualDocNString
            const lastDoc = docs.find((doc) => doc.id === (actualDocName))
            
            var answers
            if(lastDoc.data().answers.length < 150) //maximun answers
            {
                var docRef = db.collection("answers").doc(actualDocName);
                docRef.onSnapshot((doc) => {
                    docRef.update({
                        answers: firebase.firestore.FieldValue.arrayUnion(this.state.answers)
                    });
                });
            }
            else
            {
                answers = [] //new doc
                answers.push(this.state.answers)
                db.collection('answers').doc("answers" + utils.surveyToView + nextDocN).set({answers:answers});
            }         
        })

        this.refs["lastScreen"].className = "sent";
        this.refs["send"].disabled = true;
        this.refs["navBar"].className = "navigationBar hiddenNavigation";
        if(field !== undefined){
        field.disabled = true;
        }
        this.doBackup()
    }

    doBackup = () =>{
        const date = new Date();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = date.getUTCDate();
        var year = date.getUTCFullYear();
        
        var folderName = year + " " + month
        var dateString = day + " " + month+ " " + year + " " + date.toTimeString()
        db.collection('surveys').get().then((snapShots) => {
            const surveys = []
            for (let survey of snapShots.docs) {
                surveys.push({
                    id: survey.id,
                    data: survey.data()
                })
            }
            const blob = new Blob([JSON.stringify(surveys)],{type:'application/json'});
            firebase.storage().ref().child('00 Surveys/'+ folderName + "/" + "surveys " + dateString + '.json').put(blob)
        })
        db.collection('answers').get().then((snapShots) => {
            const answers = []
            for (let answer of snapShots.docs) {
                answers.push({
                    id: answer.id,
                    data: answer.data()
                })
            }
            const blob = new Blob([JSON.stringify(answers)],{type:'application/json'});
            firebase.storage().ref().child('00 Answers/'+ folderName + "/" + dateString + '.json').put(blob)
        })
    }

    manageMapAnswer(question, val){
        this.answer(question, val.answer)
    }

    manageMapSearch(question,val){
        console.log("answer for " + question['questionId']);
        var ms = this.state.mapSearch;
        ms[question['questionId']] = val;
        console.log(ms);
        this.setState({
            mapSearch: ms
        });
    }

    posibleAnswers(question) {
        const posibleAnswers = question['posibleAnswers']
        switch (question['type']) {
            case "map":
                return(
                    <>
                    <div className="searchBox"><LocationSearchInput placeholder={this.textInLanguage(utils.searchTranslate)} stateUpdatingCallback={(val) => {this.manageMapSearch(question, val)}}/></div>
                    <div className={"questionAnswers "+question['type']}>
                       
                       <MapContainer language = {this.state.language} pinSymbol={'../UX_' + question['markerName']['en'] +'.png'} 
                       mapStyles = {question['mapStyle']} markerName = {this.textInLanguage(question['markerName'])} 
                       questionID={question['questionId']} mapSearch={this.state.mapSearch[question['questionId']]} position = {question['position']} 
                       otherMarker={this.tryGetAnswer(question["otherMapID"])} otherPin = {'../UX_' + question['otherPin'] +'.png'}
                       stateUpdatingCallback={(val) => {this.manageMapAnswer(question, val)}}>

                       </MapContainer>
                        
                    </div>
                    
                    </>
                )
            case "discretizedSlider":
                
                return(
                    <div className={"questionAnswers "+question['type']}>
                       <DiscretizedSlider labels = {question['posibleAnswers']} 
                        ref = {"discretizedSlider"+question['questionId']}
                        OnChange = {() => this.answerDiscretizedSlider(question)}
                        stateUpdatingCallback={() => {this.answerDiscretizedSlider(question)}}></DiscretizedSlider>
                    </div>
                )
            case "timePicker":
                return(
                    <div className={"questionAnswers " + question['type']}>
                        <TimePicker onClose = {() => this.answerTimePicker(question)}
                          showSecond={false} minuteStep={5} ref = {"timePicker"+question['questionId']+"1"}/>
                        <TimePicker onClose = {() => this.answerTimePicker(question)}
                          showSecond={false} minuteStep={5} ref = {"timePicker"+question['questionId']+"2"}/>
                    </div>
                )
            case "textIntroduction":
                return(
                    <div className="questionAnswers">
                        <input type="text" onInput = {() => this.answerTextIntroduction(question)} 
                            className={question['type']} ref = {"textIntroduction"+question['questionId']}></input>
                    </div>
                )
            case "selection":
                return (
                <div className="questionAnswers">
                    {posibleAnswers.map((ans,i) =>
                        <button key = {i} onClick = {() => this.answer(question, ans)} className={"buttonDiv buttonSel " 
                        +(this.state.answers["answer"+question['questionId']] === ans ? "selected" : "unselected")}>
                             <div className="buttonText"><span>{this.textInLanguage(ans)}</span></div>
                             <img alt="" className="circle uxElement" src= {"../UX_circle.png"} />
                             <img alt="" className="tick uxElement" src= {"../UX_tick.png"} />
                        </button>)}
                </div>);
            case "textMultipleSelection":
                return (
                <div className="questionAnswers">
                    {posibleAnswers.map((ans,i) =>
                        <button key = {i} onClick = {() => this.answerMultipleSelection(question, ans["textId"], "textId", "textMultipleSelection")} 
                        ref = {"textMultipleSelection"+question['questionId']+ans['textId']}
                        className={"buttonDiv buttonSel unselected"}>
                             <div className="buttonText"><span>{this.textInLanguage(ans)}</span></div>
                             <img alt="" className="circle uxElement" src= {"../UX_circle.png"} />
                             <img alt="" className="tick uxElement" src= {"../UX_tick.png"} />
                        </button>)}
                </div>);
            case "imageSelection":
                return (
                <div className="questionAnswers">
                    {
                    posibleAnswers.map((ans,i) =>
                        <button key = {i} alt = {ans} type="image" onClick = {()=> this.answer(question, ans)}
                        className={"buttonSel " +(this.state.answers["answer"+question['questionId']] === ans ? "selected" : "unselected")}>
                            <img alt="" className="buttonImg" src= {"../UX_"+ans["image"]} />
                            <img alt="" className="circle uxElement" src= {"../UX_circle.png"} />
                            <img alt="" className="tick uxElement" src= {"../UX_tick.png"} />
                            <div className="buttonText"><span>{this.textInLanguage(ans)}</span></div>
                        </button>
                    )
                    
                    }
                </div>);
            case "imageMultipleSelection":
                return (
                <div className="questionAnswers" ref = {"imageMultipleSelection"+question['questionId']}>
                    {posibleAnswers.map((ans,i) =>
                        
                        <button key = {i} className={"buttonSel unselected"} ref = {"imageMultipleSelection"+question['questionId']+ans['image']}
                       type = 'image' onClick = {()=> this.answerMultipleSelection(question, ans['image'], 'image', "imageMultipleSelection")}>
                            <img alt="" className="buttonImg" src= {"../UX_"+ans["image"]} />
                            <img alt="" className="circle uxElement" src= {"../UX_circle.png"} />
                            <img alt="" className="tick uxElement" src= {"../UX_tick.png"} />
                            <div className="buttonText"><span>{this.textInLanguage(ans)}</span></div>
                        </button>
                        
                    )}
                </div>);
            case "rangeSlider":
                return (
                <div className="questionAnswers">
                    <input type="range" min={posibleAnswers[0]} max={posibleAnswers[1]} 
                           className={question['type']}
                           onChange = {()=> this.onChangeRangeSlider(question)}
                           onInput = {()=> this.onChangeRangeSlider(question)}
                           ref = {"slider"+question['questionId']}></input>
                    <span ref={"sliderValue"+question['questionId']}></span>
                 </div>);
            case "rangeChooser":
                return (
                    <div className="questionAnswers">
                        <div className="numberChooser">
                            <div>
                                <button onClick={() => this.rangeNumberChange('min',question, 
                                                                            Number.parseInt(this.refs["minsliderValue"+question['questionId']].value)-1, 
                                                                            question['defaultAnswer'], 
                                                                            question['min'], question['max'])}><img alt="-" className="uxElement" src= {"../UX_minus.png"} /></button>
                                <input
                                    type="number"
                                    ref={"minsliderValue"+question['questionId']} 
                                    value ={this.getValue(question, question['defaultAnswer'])['min']}
                                    onChange = {()=> this.rangeNumberChange('min',question, 
                                                                            Number.parseInt(this.refs["minsliderValue"+question['questionId']].value),
                                                                            question['defaultAnswer'], 
                                                                            question['min'], question['max'])}/>
                                <button onClick={() => this.rangeNumberChange('min',question, 
                                                                            Number.parseInt(this.refs["minsliderValue"+question['questionId']].value)+1, 
                                                                            question['defaultAnswer'], 
                                                                            question['min'], question['max'])}><img alt="+" className="uxElement" src= {"../UX_plus.png"} /></button>
                            </div>
                        </div>
                        <div className="numberChooser">
                            <div>
                                <button onClick={() => this.rangeNumberChange('max',question, 
                                                                            Number.parseInt(this.refs["maxsliderValue"+question['questionId']].value)-1, 
                                                                            question['defaultAnswer'], 
                                                                            question['min'], question['max'])}><img alt="-" className="uxElement" src= {"../UX_minus.png"} /></button>
                                <input
                                    type="number"
                                    ref={"maxsliderValue"+question['questionId']} 
                                    value ={this.getValue(question, question['defaultAnswer'])['max']}
                                    onChange = {()=> this.rangeNumberChange('max',question, 
                                                                            Number.parseInt(this.refs["maxsliderValue"+question['questionId']].value), 
                                                                            question['defaultAnswer'], 
                                                                            question['min'], question['max'])}/>
                                <button onClick={() => this.rangeNumberChange('max',question, 
                                                                            Number.parseInt(this.refs["maxsliderValue"+question['questionId']].value)+1,
                                                                            question['defaultAnswer'],
                                                                            question['min'], question['max'])}><img alt="+" className="uxElement" src= {"../UX_plus.png"} /></button>
                            </div>
                        </div>
                    </div>);
            case "numberChooser":
                return (
                <div className="questionAnswers">
                    <div className="numberChooser"><div>
                        <button onClick={() => this.numberChange(question, -1, question['defaultAnswer'], question['min'], question['max'])}><img alt="-" className="uxElement" src= {"../UX_minus.png"} /></button>
                        <input
                            type="number"
                            ref={"sliderValue"+question['questionId']} 
                            value ={this.getValue(question, question['defaultAnswer'])}
                            onChange = {()=> this.numberChanged(question, Number.parseInt(this.refs["sliderValue"+question['questionId']].value), question['min'], question['max'])}/>
                        <button onClick={() => this.numberChange(question, 1, question['defaultAnswer'], question['min'], question['max'])}><img alt="+" className="uxElement" src= {"../UX_plus.png"} /></button>
                    </div></div>
                </div>);
                 
            default:
          }
    }

    sameAnswer = (answerType, posibleAnswers, answerStored, answerExpected) => {
        var same = false
        switch (answerType) {
            case "selection":
                same = _.isEqual(answerStored, answerExpected)
                break;
            case "imageSelection":
                same = answerStored === answerExpected
                break;
            case "imageMultipleSelection":
                var answerPositions = []
                answerStored.forEach((ans, i) => {
                    if(ans === '1')
                        answerPositions.push(i)
                });
                answerPositions.forEach(pos =>{
                    if(posibleAnswers[pos]['image'] === answerExpected)
                        same = true
                })
                break;
            case "textMultipleSelection":
                var answerPositions = []
                answerStored.forEach((ans, i) => {
                    if(ans === '1')
                        answerPositions.push(i)
                });
                answerPositions.forEach(pos =>{
                    if(posibleAnswers[pos]['textId'] === answerExpected)
                        same = true
                })
                break;
            case "rangeSlider":
                same = false //algun rango podria ser
                break;
                default:
          }
          return same
    }

    filterConditionedQuestions = (question, questions) => {
        if(!question['condition'])
            return true
            
        const condition = question['condition']
        var answersId = "answer" + condition['questionId']
        //console.log(answersId);
        if(!this.state.answers[answersId])
            return false
            
        const conditionQuestion = questions.find(function(question) {return question.questionId === condition['questionId'];})

        if(condition['multiple'] === "or")
        {
            var same = false
            condition['answer'].forEach(ans =>{
                if(this.sameAnswer(conditionQuestion['type'], conditionQuestion['posibleAnswers'], this.state.answers[answersId], ans['image']))
                    same = true
            })
            return same
        }
        else if(this.sameAnswer(conditionQuestion['type'], conditionQuestion['posibleAnswers'], this.state.answers[answersId], condition['answer']))
            return true
        
        delete this.state.answers['answer' + question['questionId']]  
        return false;
    }

    questionGroupsByScreenNumber = (questions) =>{
        var groups = []
        questions.forEach((question) =>{
            if(groups[question['screenNumber']-1] === undefined)
                groups[question['screenNumber']-1] = []
            groups[question['screenNumber']-1].push(question['questionId'])
        })
        return groups
    }

    selectStyleQuestionGroup = (groupId) => {
        if(groupId === this.state.currentScreen)
            return "visible"
        if(groupId <= this.state.currentScreen-1)
            return "hidden previous"
        else if(groupId >= this.state.currentScreen+1)
            return "hidden next"
        
        return "hidden"

    }
    questionsRender = (questions) => {
        var groups = this.questionGroupsByScreenNumber(questions);

        if(this.state.totalScreens < 1){
            this.setState({totalScreens:groups.length + 1});
        }

        console.log(this.state.currentScreen + " / " + this.state.totalScreens + " screens");



        return groups.map((group, index) =>
            this.returnGroup(questions,group, index)
            )
    }

    returnGroup = (questions,group, index) => {

        var groupQuestions = questions.filter(question => group.includes(question['questionId'])===true);
        var clName = "centered";
        groupQuestions.forEach((question) =>{
            if(question['style'] === "mapstyle"){
                clName = "centered2";
                return;
            }
        })
        return(
        <div key = {index} className = {"question " + this.selectStyleQuestionGroup(index)}>
                
                <div className={clName}>
                {
                    groupQuestions
                    //.filter(question => this.filterConditionedQuestions(question, questions))
                    .map((question, index) => 
                        <div key = {index} className = {question['style'] + " questionBox condition condition_"+this.filterConditionedQuestions(question, questions)}>
                            <div className="questionText">
                                {this.textInLanguage(question['text'])}
                                </div>
                            {this.posibleAnswers(question)}
                        </div>
                    )}
                </div>
            </div>
        )
    }
    
    titleDiv = (title) => {
        return(

                <img alt="TITLE" id="title" src="../UX_logo.png"/>
    
        )
    }

    initialScreenRender = (questions) =>{
        //if(this.state.finalScreen)
        //{
            //console.log(this.state.screenNumber);
            return(
                <div className = {"initialScreen question " + (this.state.currentScreen===0 ? "visible" : "hidden previous")}>
                    <div className="centered2">
                            <span className="horCentered leaveLotSpace">{this.textInLanguage(utils.helloMsgTranslate1)}</span>
                            <button ref="start" className={"sendButton startButton horCentered leaveLotSpace" + (this.state.currentScreen !== 0 ? " started" : "")} onClick = {() => this.onNext(this.state.currentScreen + 1, questions)}>
                                <div/>
                                <img alt="send" src="../UX_start.png" />
                                <span>{this.textInLanguage(utils.startTraductions)}</span>
                            </button>
                            <span className="horCentered leaveMidSpace">{this.textInLanguage(utils.helloMsgTranslate2)}</span>
                            
                        </div>
                </div>)
        //}
    }



    finalScreenRender = () =>{
        //if(this.state.finalScreen)
        //{
            return(
                <div className = {"lastScreen question " + (this.state.finalScreen ? "visible" : "hidden next")}>
                    
                        <div ref="lastScreen" className="notSent">

                            <div className="sendCondition preSend centered2">
                            

                                

                                

                                <button ref="send" className="sendButton horCentered leaveLotSpace" onClick = {() => this.onSubmit()}>
                                    <div/>
                                    <img alt="send" src="../UX_send.png" />
                                    <span>{this.textInLanguage(utils.submitTraductions)}</span>
                                </button>
                                <span className="horCentered leaveMidSpace">{this.textInLanguage(utils.sendMsgTranslate)}</span>
                                {/*
                                <input type="email" ref={"email"} className="textIntroduction horCentered leaveMidSpace forEmail" placeholder={this.textInLanguage(utils.emailTranslate)}/>
                                <span className="emailExplaination horCentered leaveSpace forEmail">{this.textInLanguage(utils.emailMsgTranslate)}</span>
                                */}
                                
                            </div>
                            
                            <div className="sendCondition afterSend centered2">
                            
                                <img className="thankYou horCentered leaveLotSpace" alt="thankyou" src={"../UX_thankYou_" + this.state.language +".png"}/>
                                {this.textInLanguage(utils.goodbyMsgTranslate)}
                            </div>
                        </div>
                    
                </div>)
        //}
    }

    screenSelectors = (questions) =>{
        var isAllA = this.isAllAnswered(questions, this.state.currentScreen);
        var name = this.textInLanguage(utils.nextTraductions);
        if(this.state.currentScreen === 0)
            name = this.textInLanguage(utils.startTraductions);
        
        var leftShift = -50;

        if(this.state.currentScreen !== 0){
            leftShift = 8+10*(this.state.currentScreen-1);

            if(this.state.currentScreen >= this.state.totalScreens - 1)
                leftShift = 150;
        }

        var xShift = ' + max(calc(-40vw + 550px - '+leftShift+'%), 0px) - max(calc(-40vw - 450px + '+ leftShift + '%), 0px)';
        if(leftShift < 0 || leftShift > 100)
            xShift = '';

        var xTranslate = 'calc('+(leftShift-100)+'%' + xShift+')';

        return(
            <>
            <div id='footer' ref="navBar" className = 'navigationBar'>
                
                <button className =  {"navButton nextButton " + ((isAllA && !this.state.finalScreen) ? "activeNav" : "inactiveNav")} 
                onClick = {()=> this.onNext(this.state.currentScreen + 1, questions)} disabled={!isAllA || this.state.finalScreen}>
                    <div>{name}</div>
                    <img alt=">" src= {"../UX_next.png"} />
                </button>

                

                <button className = {"navButton previousButton " + (this.state.currentScreen !== 0 ? "activeNav" : "inactiveNav")}  
                onClick = {()=> this.onNext(this.state.currentScreen - 1, questions)}
                disabled = {this.state.currentScreen === 0}>
                    
                    <img key={0} alt = "<" src= {"../UX_previous.png"} />
                </button>
            </div>
            <div className="progressBar">

                {this.progressBanners(10, xShift)}
                <img alt="" 
                    style={{/*'-ms-transform': 'translate('+xTranslate+', -50%)',*/
                            transform: 'translate('+xTranslate+', -50%)'}} 
                    className="progressHandle" src="../UX_BK.png"/>
            </div>
            </>
        );
            
    }

    progressBanners = (numBanners, xShift) =>{
        var bannerShift = -20*this.state.currentScreen+100;

        if(this.state.currentScreen === 0 || this.state.currentScreen >= this.state.totalScreens - 1)
            bannerShift = 0;

        const banners = []
        for (var i = 0; i < numBanners + 1; i++){
            //banners.push(<img className={"banner backgroundBanner " + (this.state.currentScreen === i ? "shownBckBanner" : "hiddenBanner")} 
            //    style={{/*'-ms-transform': 'translate(calc(-50%'+xShift+' + ' + (2.5*bannerShift) + 'px), -50%)',*/
            //            transform: 'translate(calc(-50%'+xShift+' + ' + (2.5*bannerShift) + 'px), -50%)'}} 
            //    alt="" src={"../UX_"+i.toLocaleString(undefined, {minimumIntegerDigits:2})+"B.png"}/>)
            banners.push(<img className={"banner backgroundBanner " + (this.state.currentScreen === i ? "shownBanner" : "hiddenBanner")} 
                style={{/*'-ms-transform': 'translate(calc(-50%'+xShift+' + ' + (2.5*bannerShift) + 'px), -50%)',*/
                        transform: 'translate(calc(-50%'+xShift+' + ' + (2.5*bannerShift) + 'px), -50%)'}} 
                alt="" src={"../UX_"+i.toLocaleString(undefined, {minimumIntegerDigits:2})+"B.png"}/>)
            banners.push(<img className={"banner " + (this.state.currentScreen === i ? "shownBanner" : "hiddenBanner")} 
                style={{/*'-ms-transform': 'translate(calc(-50%'+xShift+' + ' + bannerShift + 'px), -50%)',*/
                        transform: 'translate(calc(-50%'+xShift+' + ' + bannerShift + 'px), -50%)'}} 
                alt="" src={"../UX_"+i.toLocaleString(undefined, {minimumIntegerDigits:2})+".png"}/>)
        }

        return banners;
    }

    textInLanguage = (text) =>{
        return utils.languageFilter(text, this.state.language)
    }

    languageSelection = () => {
        return (
            <div id="languageSelector">
                {utils.languages.map((language, i) =>
                    <button className={"buttonDiv buttonSel " + (this.state.language===language?"selected":"unselected")} key = {i} onClick = {() => this.setState({language: language})}>
                        <div className="buttonText"><span>{language}</span></div>
                    </button>
                )}                
            </div>
        )
    }

    

    render(){
        const surveyId = utils.surveyToView

        const {surveys} = this.state
        const surveyData = surveys && surveys.find(function(survey) {return survey.id === surveyId;});
        //console.log(surveyData && surveyData.data['questions'].length);

        return(
            <>
            
                { surveyData &&
                    
                    <div id='container'>
                        <div id='header'>
                            {this.titleDiv(surveyData.data['surveyName'])}
                            {this.languageSelection()}
                        </div>

                        <div id='questionContainer'>
                            {this.initialScreenRender(surveyData.data['questions'])}
                        
                            {this.questionsRender(surveyData.data['questions'])}

                            {this.finalScreenRender()}
                        </div>

                        {this.screenSelectors(surveyData.data['questions'])}
                        

                    </div>                  
                }
            </>
        )
    }
}